import { GET_CAROUSEL_IMAGES_FAILURE, GET_CAROUSEL_IMAGES_LOADING, GET_CAROUSEL_IMAGES_SUCCESS } from '../actions/carouselImages'

const initialState = {
  isLoading: true,
  images: [],
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CAROUSEL_IMAGES_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case GET_CAROUSEL_IMAGES_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case GET_CAROUSEL_IMAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        images: payload,
      }
    default:
      return state
  }
}
